import React from "react";
import { statusClass } from "@/lib/constants";

export default function StatusBadge({ status, testid }) {
  if (!status) return null;
  return (
    <span className={`status-chip ${statusClass(status)}`} data-testid={testid}>
      <span className="status-dot" /> {status}
    </span>
  );
}
